<template>
  <div class="container2 container3">
    <!-- <div class="search-line">
      <el-button type="primary">工程验收</el-button>
      <el-button type="primary" @click="openProjectSelector" plain>切换工程</el-button>
      <div class="search-form-group">
        <label class="group-label">显示周期</label>
        <el-radio-group v-model="period" size="medium">
          <el-radio-button label="day">按日</el-radio-button>
          <el-radio-button label="week">按周</el-radio-button>
          <el-radio-button label="month">按月</el-radio-button>
        </el-radio-group>
      </div>
    </div> -->
    <GridLayout>
      <ChartPanel :config="config1" />
      <ChartPanel :config="config2" />
      <!-- <ChartPanel :config="config3" />
      <ChartPanel :config="config4" /> -->
    </GridLayout>
    
  </div>
</template>

    
<script>
import ChartPanel from "../../../components/chart/panel1";
import GridLayout from "../../../components/layout/gridEn";

export default {
  data() {
    return {
      search: {
        roadName: "",
        roadType: "",
        pageSize: 10,
        pageNo: 1,
      },
      
      config1: {
        title: "每日施工里程",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日施工里程",
            color: "#f6c018",
            content: '0',
            percent: '无数据',
            unit: "",
            name1: '今日施工里程',
            name2: '平均施工里程'
          },
          {
            id: this.uuid(),
            title: "当前工程进度",
            color: "#4facf9",
            content: '0',
            percent: '无数据',
            unit: "",
            name1: '当前进度',
            name2: '待完成'
          },
        ],
        chartOption:{
          series:[]
        }
      },
      config2: {
        title: "每日施工时长",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日施工时长",
            color: "#f6c018",
            content: '0',
            percent: '无数据',
            unit: "",
            name1: '今日施工时长',
            name2: '平均施工时长'
          },
          {
            id: this.uuid(),
            title: "今日设备开工率",
            color: "#4facf9",
            content: '0',
            percent: '无数据',
            unit: "",
            name1: '今日开工率',
            name2: '平均开工率'
          },
        ],
        chartOption:{
          series:[]
        }
      },
      config3: {
        title: "压实度合格率统计",
        circleConfig: [
          {
            title: "今日压实度合格率",
            id: this.uuid(),
            color: "#f6c018",
            content: "0",
            percent: '无数据',
            unit: "",
            name1: '今日合格率',
            name2: '平均合格率',
          },
        ],
        chartOption:{
          series:[]
        }
      },
      config4: {
        title: "平均摊铺温度统计",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日摊铺平均温度",
            unit: "",
            name1: '今日平均温度',
            name2: '平均摊铺温度',
            color: "#e86b59",
            content: "0",
            percent: '无数据',
          },
        ],
        chartOption:{
          series:[]
        }
      },
    };
    
  },
  props:{
    processDate: {
      type: Object,
      default: function(){
        return {}
      }
    },
    timeDate: {
      type: Object,
      default: function(){
        return {}
      }
    },
    icvDate: {
      type: Object,
      default: function(){
        return {}
      }
    },
    temperatureDate: {
      type: Object,
      default: function(){
        return {}
      }
    },
    workType:{
      type: Number,
      default: function(){
        return 2
      }
    }
  },
  computed: {},
  created() {},
  mounted() {
  },
  methods: {
    getStatistics() {
      this.getStatistics3();
    },
    getStatistics1(res){
      //console.log(res)
      console.log(this.workType)
      const xAxisList = res.data.map((item) => item.name);
      const series = [{
        name: this.workType>2?"每日作业里程":"每日作业面积",
        type: "bar",
        barWidth: 10,
        data: res.data.map((item) => {
          return item.values[0].toFixed(2);
        }),
        
      },{
        name: "工程进度",
        type: "line",
        yAxisIndex: 1,
        data: res.data.map((item) => {
          return (item.values[1]*100).toFixed(2);
        }),
      }];
      this.config1 = {
        title: this.workType>2?"每日施工里程":"每日施工面积",
        
        circleConfig: [
          {
            id: this.uuid(),
            title: this.workType>2?"今日施工里程":"今日施工面积",
            color: "#f6c018",
            content: this.workType>2?  res.meanMileage.toFixed(2):res.meanArea.toFixed(2),
            percent:  this.workType>2? res.mileage.toFixed(2):res.area.toFixed(2),
            unit: this.workType>2?"km":"㎡",
            name1: this.workType>2?'今日施工里程':'今日施工面积',
            name2: this.workType>2?'平均施工里程':'平均施工面积',
          },
          {
            id: this.uuid(),
            title: "当前工程进度",
            color: "#4facf9",
            content: (100 - (res.process*100)).toFixed(2),
            percent: (res.process*100).toFixed(2),
            unit: "%",
            name1: '当前进度',
            name2: '待完成'
          },
        ],
        chartOption: Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              data: [this.workType>2?"每日作业里程":"每日作业面积","工程进度"],
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  }
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            yAxis: [
              {
                  type: 'value',
                  name: this.workType>2?'(km)':'(㎡)',
                  // interval: '',
                  splitLine:{
                    show:false
                  },
                  axisLabel:{
                    lineStyle:{
                      color: '#878787'
                    },
                    // formatter: '{value} KM'
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#878787'
                    }
                  },
                  axisTick:{
                    show:false
                  }
              },
              {
                  type: 'value',
                  name: '',
                  min: 0,
                  max: 100,
                  interval: 25,
                  splitLine:{
                    show:false
                  },
                  axisLabel:{
                    lineStyle:{
                      color: '#878787'
                    },
                    formatter: '{value} %'
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#878787'
                    }
                  },
                  axisTick:{
                    show:false
                  }
              }
            ],
            series: series,
          }
        ),
      };
      console.log(this.config1)
    },
    
    getStatistics2(res){
      //console.log(res)
      const xAxisList = res.data.map((item) => item.name);
      const series = [{
        name: "每日施工时间",
        type: "bar",
        barWidth: 10,
        data: res.data.map((item) => {
          return item.values[0].toFixed(2);
        }),
        
      },{
        name: "设备利用率",
        type: "line",
        yAxisIndex: 1,
        data: res.data.map((item) => {
          return (item.values[1]*100).toFixed(2);
        }),
      }];
      this.config2 = {
        title: "每日施工时长",
        
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日施工时长",
            color: "#f6c018",
            content: res.meanWorkTime.toFixed(2),
            percent: res.workTime.toFixed(2),
            unit: "H",
            name1: '今日施工时长',
            name2: '平均施工时长'
          },
          {
            id: this.uuid(),
            title: "今日设备开工率",
            color: "#4facf9",
            content: (res.meanOnlineRate*100).toFixed(2),
            percent: (res.onlineRate*100).toFixed(2),
            unit: "%",
            name1: '今日开工率',
            name2: '平均开工率'
          },
        ],
        chartOption: Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              data: ["每日施工时间","设备利用率"],
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  }
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            yAxis: [
              {
                  type: 'value',
                  name: '(H)',
                  interval: 25,
                  splitLine:{
                    show:false
                  },
                  axisLabel:{
                    lineStyle:{
                      color: '#878787'
                    },
                    // formatter: '{value} H'
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#878787'
                    }
                  },
                  axisTick:{
                    show:false
                  }
              },
              {
                  type: 'value',
                  name: '',
                  min: 0,
                  max: 100,
                  interval: 25,
                  splitLine:{
                    show:false
                  },
                  axisLabel:{
                    lineStyle:{
                      color: '#878787'
                    },
                    formatter: '{value} %'
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#878787'
                    }
                  },
                  axisTick:{
                    show:false
                  }
              }
            ],
            series: series,
          }
        ),
      };
    },
    // 压实合格率
    getStatistics3(res) {
      const xAxisList = res.data.map((item) => item.name);
      const series = {
        name: "压实度合格率",
        type: "line",
        data: res.data.map((item) => {
          return (item.value*100).toFixed(2);
        }),
        areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0, color: '#4FABF9' // 0% 处的颜色
              }, {
                  offset: 1, color: '#ffffff' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
        },
      };
      this.config3 = {
        title: "压实度合格率统计",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日压实度合格率",
            color: "#f6c018",
            content: (res.passRate * 100).toFixed(2),
            percent: (res.meanPassRate * 100).toFixed(2),
            // content: 50,
            // percent: 50,
            unit: "%",
            name1: '今日合格率',
            name2: '平均合格率'
          },
        ],
        chartOption: Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              data: ["压实度合格率"],
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  }
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "(%)",
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  },
                  // formatter: '{value} %'
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            series: series,
          }
        ),
      };
    },
    getStatistics4(res) {
      const xAxisList = res.data.map((item) => item.name);
      const series = {
        name: "平均摊铺温度",
        type: "line",
        data: res.data.map((item) => {
          return item.value.toFixed(2);
        }),
        lineStyle: {
          color: '#E96B59'
        },
        itemStyle: {
          color: '#E96B59'
        },
        areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                  offset: 0, color: '#E96B59' // 0% 处的颜色
              }, {
                  offset: 1, color: '#ffffff' // 100% 处的颜色
              }],
              global: false // 缺省为 false
            }
        },
      };
      this.config4 = {
        title: "平均摊铺温度统计",
        circleConfig: [
          {
            id: this.uuid(),
            title: "今日摊铺平均温度",
            color: "#E96B59",
            content: res.meanTemperatur == null?0:res.meanTemperature.toFixed(2),
            percent: res.avgTemperatrue.toFixed(2),
            unit: "℃",
            name1: '今日平均温度',
            name2: '平均摊铺温度'
          },
        ],
        chartOption: Object.assign(
          {},
          {
            dataZoomEnd: Math.min(100, Math.ceil((8 / xAxisList.length) * 100)),
            legend: {
              data: ["平均摊铺温度"],
            },
            xAxis: [
              {
                type: "category",
                data: xAxisList,
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  }
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "(℃)",
                splitLine:{
                  show:false
                },
                axisLabel:{
                  lineStyle:{
                    color: '#878787'
                  },
                  // formatter: '{value} ℃'
                },
                axisLine:{
                  lineStyle:{
                    color:'#878787'
                  }
                },
                axisTick:{
                  show:false
                }
              },
            ],
            series: series,
          }
        ),
      };
    },
  },
  components: { ChartPanel, GridLayout },
  watch: {
    // 每日作业里程
    processDate: function (newValue){
      // if(newValue.data.length > 0){
        this.getStatistics1(newValue)
      // }
      
    },
    timeDate: function (newValue){
      // if(newValue.data.length > 0){
        this.getStatistics2(newValue)
      // }
      
    },
    // icvDate: function (newValue){
    //   this.getStatistics3(newValue)
    // },
    // temperatureDate: function (newValue){
    //   this.getStatistics4(newValue)
    // },
  }
};


</script>

<style  lang="scss">
.container3{
.panel-wrapper{
    border: none !important;
  }
}
</style>

<style lang="scss" scoped="">
.container2{
  width: 100%;
}
</style>